export default "__VITE_ASSET__09139992__"